export function initBangGiaDs() {
	const accordion = document.querySelector(
		"[data-js-target='banggia-ds-accordion']"
	);

	if (!accordion) return;

	const items = accordion.querySelectorAll("[data-js-item]");

	accordion.addEventListener("click", (event) => {
		const trigger = event.target.closest(
			"[data-js-action='toggle-accordion']"
		);
		if (!trigger) return;

		const item = trigger.closest("[data-js-item]");
		if (!item) return;

		const panel = item.querySelector("[data-js-panel]");
		const isActive = item.classList.contains("is-active");

		if (isActive) return;

		items.forEach((entry) => {
			entry.classList.remove("is-active");

			const entryButton = entry.querySelector(
				"[data-js-action='toggle-accordion']"
			);
			const entryPanel = entry.querySelector("[data-js-panel]");
			const entryIcon = entry.querySelector(".head i");

			if (entryButton) {
				entryButton.setAttribute("aria-expanded", "false");
			}

			if (entryPanel) {
				entryPanel.hidden = true;
			}

			if (entryIcon) {
				entryIcon.classList.remove("fa-minus");
				entryIcon.classList.add("fa-plus");
			}
		});

		if (!panel) return;

		item.classList.add("is-active");
		trigger.setAttribute("aria-expanded", "true");
		panel.hidden = false;

		const icon = trigger.querySelector("i");
		if (icon) {
			icon.classList.remove("fa-plus");
			icon.classList.add("fa-minus");
		}
	});

	items.forEach((item) => {
		const panel = item.querySelector("[data-js-panel]");
		if (panel) {
			panel.hidden = !item.classList.contains("is-active");
		}
	});
}